import "@babel/polyfill";
import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import registrations from './modules/registrations'
import sessionConnections from './modules/sessionConnections'
import device from './modules/device'
import feathersVuex from 'feathers-vuex'
import feathersClient from '../api/feathers-client'

const { service, auth, FeathersVuex } = feathersVuex(feathersClient, { idField: '_id' })

/*
const data = {payload: {}};
feathersClient.service('authentication').create(data).then((jwt)=>{
    console.log(jwt);
});
*/


Vue.use(Vuex)
Vue.use(FeathersVuex)



export default new Vuex.Store({
    strict: true,
    defaultOptions: {
        idField: '_id'
    },
    plugins: [
        //service('chat', chat),
        service('users'),
        service('webcast',{
            keepCopiesInStore: true,
            debug: true
        }),
        service('authentication'),
        service('appsettings'),
        service('registrations', registrations),
        service('attendees'),
        service('stream'),
        service('webcast-session'),
        service('page-settings'),
        service('reg-form'),
        service('landing-content'),
        service('widgets'),        
        service('qna', {debug: true}),
        service('session-connections', sessionConnections),
        service('devices', device),

        auth({
            userService: 'users'
        })
    ]
})